<div class="hpPopup">
    <!-- <div clas="content-container"> -->
        <div><img src="/assets/img/close.png" (click)="hidemodal()"/></div>

        <h3>Are You a US Healthcare Professional?</h3>
        <p>This site is intended for US healthcare professionals only. By clicking “YES,” you are declaring and confirming that you are a healthcare professional and have read and understood this disclaimer.</p>
        <div class="btn-main">
            <button (click)="hidemodal()">YES</button>
            <button routerLink="/patient" id="btnNo">NO</button>
        </div>
    <!-- </div> -->
</div>
<div class="hp-modal-background"></div>
